import { apiFetch, authHeader } from '../../shared/api/httpClient';
import { clientHeaders } from '../../shared/lib/device';
import type { RaffleRecentEvent } from '../wallet/api';

export type DrawHistoryResponse = {
  server_time?: number;
  draws?: RaffleRecentEvent[];
  /** null 表示没有更早的了。与 `/history/mine` 同一套不透明 keyset 游标。 */
  next_cursor?: string | null;
};

/**
 * 这个国家最近已经出结果的期。
 *
 * <p>**不是** `/api/raffle` 里那个 `recent_events` —— 那个 JOIN 了
 * raffle_entry，只返回玩家参加过的期。
 */
export function fetchDrawHistory(token: string | null, cursor?: string | null, limit = 50) {
  const params = new URLSearchParams({ limit: String(limit) });
  if (cursor) params.set('cursor', cursor);
  return apiFetch<DrawHistoryResponse>(`/api/v1/raffle/history?${params.toString()}`, {
    headers: {
      ...clientHeaders(),
      ...authHeader(token),
    },
    cache: 'no-store',
  });
}

export type MyDrawHistoryResponse = {
  server_time?: number;
  /**
   * 参与 / 中奖 / 累计奖金。**只有第一页带**，后面的页是 null —— 这三个数
   * 描述的是全部历史，不是这一页，前端要一直用第一页拿到的那份。自己把已加载
   * 的页加起来的话，翻一页数字就变一次，玩家会以为自己刚中了什么。
   */
  summary?: { events?: number; won?: number; prize_total?: number } | null;
  draws?: RaffleRecentEvent[];
  /** null 表示没有更早的了 */
  next_cursor?: string | null;
};

/**
 * 我参与过的期，按游标往前翻。
 *
 * <p>与 `fetchDrawHistory` 的区别不只是过滤条件：那个是「这个国家最近 50 期」，
 * 没有翻页，访客也能看（公开的公平性记录）；这个是「我参与过的全部」，必须登录，
 * 按 `scheduled_at:event_id` 做 keyset 翻页。
 *
 * <p><b>为什么不是 offset。</b> 这个列表最上面随时会插进新结算的期。用 offset
 * 的话，翻第二页时前面多了一期，第 50 条就会被推成第 51 条 —— 玩家看到同一期
 * 出现两次，或者中间少一期。keyset 从「上一页最后一期之前」接着取，插多少期
 * 都不影响。
 */
export function fetchMyDrawHistory(token: string | null, cursor?: string | null, limit = 50) {
  const params = new URLSearchParams({ limit: String(limit) });
  if (cursor) params.set('cursor', cursor);
  return apiFetch<MyDrawHistoryResponse>(`/api/v1/raffle/history/mine?${params.toString()}`, {
    headers: {
      ...clientHeaders(),
      ...authHeader(token),
    },
    cache: 'no-store',
  });
}
